<template>

  <v-btn @click="likeAndDislike(profileId, hasMyLike === false)" icon class="mx-5">
    <v-icon color="primary" v-if="hasMyLike === true">mdi-thumb-up</v-icon>
    <v-icon v-else>mdi-thumb-up</v-icon>

    <span v-if="likes <= 99">{{likes}}</span>
    <span v-else>99+</span>
  </v-btn>

</template>

<script>
import Profiles from "@/services/Profiles";
import store from "../store";

export default {
  props: ['profilePosition', 'profileId', 'hasMyLike', 'likes'],
  data: () => ({

  }),
  methods: {
    likeAndDislike(profileId, upOrDown){
      Profiles.likesAndDislikes(store.state.tokenStored, {'targetProfileId': parseInt(profileId, 10), 'upOrDown': upOrDown}).then((response)=> {

        if (!response || !response.success || response.success === false) {
          alert('Algo no ha ido bien, intentalo de nuevo')
          return
        }

        this.$emit("update-likes", this.profilePosition, (upOrDown ? this.likes + 1 : this.likes -1), upOrDown === true);
      })
    }
  }
}
</script>